import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';

// Transition créative avec animation de caractères
const CreativeLanguageTransition = () => {
  const { i18n } = useTranslation();
  const [showTransition, setShowTransition] = useState(false);
  const [currentLang, setCurrentLang] = useState(i18n.language);
  
  // Animation de caractères pour la transition
  const englishChars = "ENGLISH".split("");
  const chineseChars = "中文".split("");
  
  useEffect(() => {
    const handleLanguageChange = (newLang) => {
      if (newLang !== currentLang) {
        setShowTransition(true);
        
        setTimeout(() => {
          setShowTransition(false);
          setCurrentLang(newLang);
        }, 1500);
      }
    };
    
    i18n.on('languageChanged', handleLanguageChange);
    
    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, [i18n, currentLang]);
  
  return (
    <AnimatePresence>
      {showTransition && (
        <TransitionOverlay
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
        >
          <TransitionContent>
            {i18n.language === 'zh' 
              ? chineseChars.map((char, index) => (
                  <CharContainer
                    key={index}
                    initial={{ y: -100, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ 
                      duration: 0.5, 
                      delay: index * 0.1,
                      type: "spring", 
                      stiffness: 200 
                    }}
                  >
                    {char}
                  </CharContainer>
                ))
              : englishChars.map((char, index) => (
                  <CharContainer
                    key={index}
                    initial={{ y: -100, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ 
                      duration: 0.5, 
                      delay: index * 0.1,
                      type: "spring", 
                      stiffness: 200 
                    }}
                  >
                    {char}
                  </CharContainer>
                ))
            }
          </TransitionContent>
          
          {/* Effet de vague en arrière-plan */}
          <BackgroundWave 
            animate={{ 
              scale: [1, 1.1, 1],
              rotate: [0, 10, 0],
              opacity: [0.2, 0.4, 0.2]
            }}
            transition={{ 
              duration: 4,
              repeat: Infinity,
              repeatType: "reverse"
            }}
            isChineseLanguage={i18n.language === 'zh'}
          />
        </TransitionOverlay>
      )}
    </AnimatePresence>
  );
};

const TransitionOverlay = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.85);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  overflow: hidden;
`;

const TransitionContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
`;

const CharContainer = styled(motion.div)`
  font-size: 4rem;
  font-weight: bold;
  color: white;
  margin: 0 5px;
  text-shadow: 0 0 20px rgba(255, 255, 255, 0.5);
`;

const BackgroundWave = styled(motion.div)`
  position: absolute;
  width: 300%;
  height: 300%;
  background: ${props => props.isChineseLanguage 
    ? 'radial-gradient(circle, rgba(255, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0) 70%)'
    : 'radial-gradient(circle, rgba(0, 0, 255, 0.1) 0%, rgba(0, 0, 0, 0) 70%)'
  };
  z-index: 1;
`;

export default CreativeLanguageTransition;